module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {



let categoryOpen = isOpen || false;
if ( 'TRUE' === node.selected || 'IMPLICIT' === node.selected ) {
    categoryOpen = true;
    node.ancestor = true;
}

const children = node.children || [];

;
__p += '\n<li class="facet_menu__item' +
((__t = ( node.ancestor ? ' facet_menu__item--current_ancestor' : '' )) == null ? '' : __t) +
'' +
((__t = ( node.current ? ' facet_menu__item--current' : '' )) == null ? '' : __t) +
'\n    ' +
((__t = ( children.length > 0 ? ' facet_menu__item--has_submenu' + (node.ancestor || node.current || categoryOpen ? ' active_scope' : '') : '' )) == null ? '' : __t) +
'">\n    <button type="button" class="facet_menu__item_name" data-search-params=\'' +
((__t = ( JSON.stringify( node.searchParams ) )) == null ? '' : __t) +
'\'>\n        ';
 if ( node.current || node.ancestor ) { ;
__p += '\n            <span class="en-item-title">' +
((__t = ( node.text )) == null ? '' : __t) +
' <span class="count">(' +
((__t = ( node.totalHits )) == null ? '' : __t) +
')</span></span>\n        ';
 } else { ;
__p += '\n            ' +
((__t = ( node.text )) == null ? '' : __t) +
' <span class="count">(' +
((__t = ( node.totalHits )) == null ? '' : __t) +
')</span>\n        ';
 } ;
__p += '\n    </button>\n    ';
 if ( children.length > 0 ) { ;
__p += '\n    ';
 if ( false ) { ;
__p += '\n        <button type="button" class="facet_menu__item_button' +
((__t = ( node.ancestor || node.current || categoryOpen ? ' active' : '' )) == null ? '' : __t) +
'"></button>\n    ';
 } ;
__p += '\n    <ul class="facet_menu facet_menu--sub facet_menu--level_' +
((__t = ( node.clusterLevel + 1 )) == null ? '' : __t) +
'' +
((__t = ( node.ancestor || node.current || categoryOpen ? ' active' : '' )) == null ? '' : __t) +
'" style="' +
((__t = ( categoryOpen ? 'display:block' : 'display:none' )) == null ? '' : __t) +
'">\n        ';
 if ( false ) { ;
__p += '\n        <li class="facet_menu__item en-filter-all">\n            <button type="button" class="facet_menu__item_name" data-search-params=\'' +
((__t = ( JSON.stringify( node.searchParams ) )) == null ? '' : __t) +
'\'>\n                <span class="en-item-title">Alle anzeigen</span>\n            </button>\n        </li>\n        ';
 } ;
__p += '\n        ';
 children.forEach( (childNode) => { ;
__p += '\n            ' +
((__t = ( render( 'factfinder-category-tree', { 'node': childNode, isOpen: categoryOpen } ) )) == null ? '' : __t) +
'\n        ';
 } ); ;
__p += '\n    </ul>\n    ';
 } ;
__p += '\n</li>\n';

}
return __p
};
